import "./style.css";
import logoFinal from "../../assets/img/logo_final.png";
import { Form, Input, Button, Select, message, Spin } from "antd";
import { useEffect, useState } from "react";
import api from "../../services/api";
import { useHistory } from "react-router-dom";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  LoadingOutlined,
} from "@ant-design/icons";
import { loginService } from "../../services/Login-Service/login-service";
import logoSETDIG from "../../assets/img/logo-setdig-branca.svg";
import logoCadmim from "../../assets/img//logo_final.png";

interface LoginProps {
  location: any;
}

const Login: React.FC<LoginProps> = (prop) => {
  let history = useHistory();
  const { Option } = Select;
  const [dominios, setDominios] = useState<any[]>();
  const [perfis, setPerfis] = useState<any[]>();
  const [usuarioLogado, setUsuarioLogado] = useState<any>();
  const [disabled, setDisabled] = useState<boolean>(false);
  const [tokenAPI, setTokenAPI] = useState<any>();
  const [usuarioAutenticado, setUsuarioAutenticado] = useState<Boolean>();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadingPerfis, setLoadingPerfis] = useState(false);
  const [loadingDominios, setLoadingDominios] = useState(false);
  const spinnerIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  useEffect(() => {
    setDisabled(false);
    setUsuarioLogado(undefined);
    getDominios();

    if (prop.location.state != undefined) {
      message.error(prop.location.state.message);
    }
  }, []);
  const getDominios = () => {
    setLoadingDominios(true);
    loginService
      .getDominios()
      .then((response) => setDominios(response))
      .finally(() => setLoadingDominios(false));
  };

  const login = () => {
    form.validateFields().then(() => {
      setLoading(true);
      loginService
        .validarUsuario(form.getFieldsValue())
        .then((response) => {
          if (response.authenticated !== false) {
            setUsuarioLogado(response);
            setLoadingPerfis(true);
            loginService
              .getPermissoes(response.usuarioID)
              .then((response) => {
                setPerfis(response.data);
              })
              .finally(() => setLoadingPerfis(false));
            setDisabled(true);
            setUsuarioAutenticado(true);
          } else {
            message.error(response.message);
          }
        })
        .finally(() => {
          setLoading(false);
          var dropdownPerfil = document.getElementById("dropdownPerfil");
          dropdownPerfil?.focus();
        });
    });
  };

  const selecionarPerfil = async () => {
    form.validateFields().then(async () => {
      let perfilSelecionado = perfis?.find(
        (p) => p.perfilID === form.getFieldValue("perfil"),
      );
      setLoading(true);
      await loginService
        .selecionarPerfil(
          perfilSelecionado?.grupoID,
          perfilSelecionado.geoEstruturaID,
        )
        .then(() => {
          sessionStorage.setItem(
            "geoEstrutura",
            perfilSelecionado?.siglaGeoEstrutura,
          );
          sessionStorage.setItem("grupo", perfilSelecionado?.nomeGrupo);
          sessionStorage.setItem("grupoID", perfilSelecionado?.grupoID);
        })
        .finally(() => setLoading(false));

      setLoading(true);
      await api
        .get(`Modulo/porperfil?perfilID=${perfilSelecionado?.grupoID}`)
        .then((response) => {
          sessionStorage.setItem("modulos", JSON.stringify(response.data));
          history.push(`/home`);
        })
        .finally(() => setLoading(false));
    });
  };

  const voltarAutenticar = () => {
    setUsuarioLogado(null);
    sessionStorage.clear();
    setPerfis([]);
    form.resetFields();
    setDisabled(false);
    setUsuarioAutenticado(false);
  };

  const botaoAcessarFocus = () => {
    var botaoAcessar = document.getElementById("logar");
    botaoAcessar?.focus();
  };

  const botaoSelecionarPerfilFocus = () => {
    var botaoSelecionarPerfil = document.getElementById("selecionarPerfil");
    botaoSelecionarPerfil?.focus();
  };

  return (
    <>
      <div className="wrapper">
        <div className="container_padrao logo">
          <img className="logo_img" src={logoFinal} />
        </div>
        <div className="container_padrao login">
          <Form form={form} className="formulario">
            <Spin spinning={loading}>
              <p className="sis-titulo">
                <span className="titulo cad">CAD</span>
                <span className="titulo mi">MI</span>
                <span className="titulo ms">-MS</span>
              </p>
              <label className="form-titulo">Autenticação do Usuário</label>
              <Form.Item
                className="input-container"
                name="usuario"
                rules={[
                  {
                    required: true,
                    message: "Favor, informe seu usuário.",
                  },
                ]}
              >
                <Input
                  placeholder="Usuario"
                  className="input"
                  disabled={disabled}
                  id="usuario"
                />
              </Form.Item>

              <Form.Item
                name="senha"
                className="input-container"
                rules={[
                  {
                    required: true,
                    message: "Favor, informe sua senha.",
                  },
                ]}
              >
                <Input.Password
                  className="input"
                  disabled={disabled}
                  id="senha"
                  placeholder="Senha"
                  iconRender={(visible) =>
                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                  }
                />
              </Form.Item>
              <Spin indicator={spinnerIcon} spinning={loadingDominios}>
                <Form.Item
                  name="dominio"
                  className="input-container"
                  initialValue={""}
                  rules={[
                    {
                      required: true,
                      message: "Favor, informe o domínio.",
                    },
                  ]}
                >
                  <Select
                    className="select"
                    placeholder="Dominio"
                    disabled={disabled}
                    showSearch
                    optionFilterProp="children"
                    onSelect={botaoAcessarFocus}
                  >
                    <Option className="opt" value="">
                      Selecione um Dominio
                    </Option>
                    {dominios?.map((dominio, key) => (
                      <Option className="opt" key={key} value={dominio.value}>
                        {dominio.text}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Spin>

              {usuarioAutenticado ? (
                <>
                  <Spin indicator={spinnerIcon} spinning={loadingPerfis}>
                    <Form.Item
                      name="perfil"
                      className="input-container"
                      initialValue={""}
                      rules={[
                        { required: true, message: "Favor, informe o perfil." },
                      ]}
                    >
                      <Select
                        loading={loadingPerfis}
                        className="select"
                        id="dropdownPerfil"
                        placeholder="Perfil"
                        onSelect={botaoSelecionarPerfilFocus}
                      >
                        <Option className="opt" value="">
                          Selecione um Perfil
                        </Option>
                        {perfis?.map((perfil, key) => (
                          <Option
                            className="opt"
                            key={key}
                            value={perfil.perfilID}
                          >
                            ({perfil.siglaGeoEstrutura}){perfil.nomeGrupo}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Spin>
                  <Form.Item>
                    <div className="form-button">
                      <Button
                        onClick={() => {
                          voltarAutenticar();
                        }}
                        danger
                        htmlType="button"
                        id="selecionarloading"
                        className="warming_button login_btn"
                      >
                        Voltar
                      </Button>
                      <Button
                        loading={loadingPerfis || loading}
                        type="primary"
                        onClick={() => {
                          selecionarPerfil();
                        }}
                        id="selecionarPerfil"
                        className="confirm_button login_btn"
                      >
                        Selecionar Perfil
                      </Button>
                    </div>
                  </Form.Item>
                </>
              ) : (
                <Form.Item>
                  <Button
                    disabled={disabled}
                    type="primary"
                    onClick={() => {
                      login();
                    }}
                    htmlType="submit"
                    id="logar"
                    className="confirm_button login_btn"
                  >
                    Acessar
                  </Button>
                </Form.Item>
              )}
            </Spin>
          </Form>
        </div>
      </div>
      <div className="rodape-portal">
        <div className="logos-grid">
          <div>
            <img src={logoCadmim} className="cadmim-logo-footer" />
          </div>
          <div className="logos-direita">
            <div className="sgi-logo">
              <img src={logoSETDIG} className="sgi-logo-img" />
            </div>
          </div>
        </div>
      </div>

      <div className="background">
        <div className="ripple"></div>
        <div className="ripple1"></div>
        <div className="ripple2"></div>
      </div>
    </>
  );
};
export default Login;
